import { computed, ref, watch } from '@vue/composition-api';

export default function useDialog({
  emit,
  value,
} = {}) {
  const dialog = ref(false);

  function showDialog() {
    dialog.value = true;
    if (!emit) {
      return;
    }
    emit('showDialog');
  }

  function closeDialog() {
    dialog.value = false;
    if (!emit) {
      return;
    }
    emit('closeDialog');
  }

  const dialogModel = computed({
    get() {
      return dialog.value;
    },
    set(val) {
      dialog.value = val;
    },
  });

  if (value !== undefined) {
    dialogModel.value = value.value;
    watch(value, () => {
      dialogModel.value = value.value;
    });

    watch(dialogModel, () => {
      emit('input', dialogModel.value);
    });
  }

  return {
    dialog,
    dialogController: {
      closeDialog,
      showDialog,
    },
    dialogModel,
  };
}
